import { useState } from "react";
import { OrderStatusLineItem, OrderStatusLineItemUpdate } from "../types/OrderStatus";

function UpdateTitle({ update }) {
  if (update.type && update.type === "alert") {
    return (
      <div className="flex items-center gap-1">
        <svg aria-hidden="true" focusable="false" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22.1646C6.47715 22.1646 2 17.6874 2 12.1646C2 6.6417 6.47715 2.16455 12 2.16455C17.5228 2.16455 22 6.6417 22 12.1646C22 17.6874 17.5228 22.1646 12 22.1646ZM12 20.1646C16.4183 20.1646 20 16.5829 20 12.1646C20 7.74627 16.4183 4.16455 12 4.16455C7.58172 4.16455 4 7.74627 4 12.1646C4 16.5829 7.58172 20.1646 12 20.1646ZM11 15.1646H13V17.1646H11V15.1646ZM11 7.16455H13V13.1646H11V7.16455Z" fill="#E10000"/>
        </svg>

        <h3 className="font-base normal-case text-[1rem] text-[#E10000]">{update.title}</h3>
      </div>
    )
  }

  return <h3 className="font-base normal-case text-[1rem]">{update.title}</h3>
}

export function OrderStatusUpdates({ lineItemStatus }) {
  const [showUpdates, setShowUpdates] = useState(false);
  
  if (lineItemStatus?.updates?.length > 0) {
    return (
      <div className="md:grid grid-cols-4 gap-x-[1.5rem]">
        <div className="col-span-1" aria-hidden="true"></div>
        <div className="col-span-3 border-t border-blush-400/75 py-[1.5rem]">
          <ul className="flex flex-col gap-y-[1.25rem] relative">
            {lineItemStatus.updates.map((update: OrderStatusLineItemUpdate, index: number) => {
              return (
                <li
                  className="list-none flex flex-col gap-y-[0.375rem]"
                  style={{
                    position: !showUpdates && index > 1 ? "fixed" : "static",
                    opacity: !showUpdates && index > 1 ? "0" : "1",
                    transition: "opacity .9s",
                    visibility: !showUpdates && index > 1 ? "hidden" : "visible",
                  }}
                  aria-hidden={!showUpdates && index > 1 ? "true" : "false"}
                >
                  {update.title &&
                    <UpdateTitle update={update} />
                  }

                  {update.text &&
                    <p className="text-[0.875rem] text-black/[.65] leading-6">{update.text}</p>
                  }

                  {update.images?.length > 0 &&
                    <ul className="flex flex-wrap items-start">
                      {update.images.map((image) => {
                        return <img src={image} className="max-w-[50%] md:max-w-[25%] pr-1 pb-1" />
                      })}
                    </ul>
                  }

                  {update.date &&
                    <p className="text-[0.875rem] text-black/[.65] italic leading-6">{update.date}</p>
                  }
                </li>
              )
            })}
          </ul>
        
          {lineItemStatus.updates.length > 2 &&
            <button
              onClick={() => setShowUpdates(!showUpdates)}
              className="text-sm underline uppercase underline-offset-4 mt-6 flex"
            >
              {showUpdates ? "Collapse previous updates" : "Show previous updates"}

                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${showUpdates && 'rotate-180'} transition-opacity`}>
                  <path d="M9.99942 11.1411L14.1242 7.0163L15.3027 8.19481L9.99942 13.4981L4.69617 8.19481L5.87467 7.0163L9.99942 11.1411Z" fill="black"/>
                </svg>
            </button>
          }
        </div>
      </div>
    )
  } else {
    return null;
  }
}